document.addEventListener('click', (event) => {
    const button = event.target.closest('.ck-faq__question');
    if (!button) return;

    const item = button.closest('.ck-faq__item');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!item || !panel) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    item.classList.toggle('is-open', !isOpen);
    panel.hidden = isOpen;
});
